import { createFileRoute, redirect } from '@tanstack/react-router'

// Old path: notification links, installed-PWA shortcuts and bookmarks still point here.
export const Route = createFileRoute('/_authenticated/inbox')({
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/everyday', search: search as never, replace: true })
  },
})
